import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import Numeral from "numeral";
import "numeral/locales/pt-br";
import { toast } from "react-toastify";
import { Breadcrumb } from "../../../components";
import { getDmService } from "../../../services/Api";
import actions from "../../../redux/modules/user";
import appConfig from "../../../config/app-config";

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      produtos: [],
      subTotal: 0,
      saldoAtual: 0
    };
  }

  componentWillMount = async () => {
    await this.getSaldoAtual();
  };

  componentDidMount = async () => {
    const { history, match, loadUser } = this.props;
    Numeral.locale("pt-br");
    await loadUser();
    await this.getSubTotal();
    const id = history.location.pathname
      .replace(match.url, "")
      .replace("/", "");
    this.getItems(id);
    history.listen(location => {
      const id = location.pathname.replace(match.url, "").replace("/", "");
      const urlId = id || false;
      this.getItems(urlId);
    });
  };

  getItems = async urlId => {
    const urlFilter = urlId
      ? `/Produto/GetListagem/?busca=&tipo=2&categoria=${urlId}&status=1&ordem=Descricao&ordemDirecao=ASC&pageNumber=1&pageSize=10`
      : `/Produto/GetListagem/?pageNumber=1&pageSize=1000&tipo=2&status=&busca=&ordem=nome&ordemDirecao=asc`;

    try {
      const produtos = await getDmService(urlFilter);
      this.setState({ produtos });
    } catch (e) {
      // Error
      console.log(e);
    }
  };

  getSaldoAtual = async () => {
    try {
      const data = await getDmService("/Orcamento/SaldoAtual");
      const { saldoAtual } = data;
      this.setState({
        saldoAtual
      });
    } catch (error) {
      console.log(error);
    }
  };

  getSubTotal = async () => {
    try {
      const items = await getDmService("/Pedido/MostraCarrinho");

      if (items.carrinho.length) {
        for (const obj of items.carrinho) {
          if (obj.tipo !== "Agência") {
            this.setState({ subTotal: obj.valorTotal });
          }
        }
      }
    } catch (err) {
      toast.error("Não foi possível atualizar os gastos atuais");
    }
  };

  listProducts() {
    const { produtos } = this.state;
    return (
      produtos.resultado &&
      produtos.resultado.map(prod => (
        <div
          key={prod.id}
          className="bx--col-xs-12 bx--col-sm-6 bx--col-md-6 bx--col-xxl-3 bx--col-xl-4 products-item"
        >
          <NavLink to={`/trade/brinde/${prod.id}`}>
            <div className="figure-products">
              <figure>
                <div
                  className="figure-img"
                  style={{
                    backgroundImage: `url('${appConfig.IMAGE_PATH +
                      prod.foto}')`
                  }}
                />
                <figcaption>
                  <span className="figure-description" title={prod.produto}>
                    {prod.produto}
                  </span>
                  <br />
                  <span className="figure-price">
                    {Numeral(prod.valor).format("$ 0.00")}
                  </span>
                </figcaption>
              </figure>
            </div>
          </NavLink>
        </div>
      ))
    );
  }

  render() {
    const { subTotal, saldoAtual } = this.state;
    const saldo = Numeral(saldoAtual).value() - subTotal;
    console.log("sub total");
    console.log(subTotal);
    return (
      <div>
        <Breadcrumb
          title="Brindes"
          description="Listagem de brindes"
          renderRight={(() => (
            <div className="bread-info">
              <span className="text">
                <span className="text-light">Meu Budget: </span>
                <strong>{Numeral(saldoAtual).format("$ 0.00")} </strong>
                {subTotal !== 0 && (
                  <React.Fragment>
                    (-
                    {Numeral(subTotal).format("$ 0.00")}
                    {`)`}
                    <span className="text-light">Saldo: </span>
                    <strong>{Numeral(saldo).format("$ 0.00")}</strong>
                  </React.Fragment>
                )}
              </span>
              <span className="text">
                {subTotal !== 0 && (
                  <React.Fragment>
                    <span className="text-light">Saldo: </span>
                    <strong>{Numeral(saldo).format("$ 0.00")}</strong>
                  </React.Fragment>
                )}
              </span>
            </div>
          ))()}
        />
        <div className="content-wrapper">
          <div className="bx--row">{this.listProducts()}</div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadUser() {
    return dispatch(actions.receiveUserData());
  }
});

const mapStateToProps = state => ({
  user: state.user.data
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Products);



// WEBPACK FOOTER //
// ./src/screens/client/agency/Products.jsx